@import "~/styles/variables";
@import "~/styles/v1/_variables.scss";

$modal-min-height: 400px;
$modal-max-height: calc(100vh - (2 * #{$space-xl}));

.Modal {
  display: flex;
  flex-direction: column;
  max-height: $modal-max-height;
  min-height: $modal-min-height;
  height: auto;
  margin: 0 $space-m;
  position: relative;
  width: 100%;
  @include box-shadow-1;

  @media (max-width: $screen-s) {
    display: block;
  }

  &.xs {
    min-height: auto;
    width: 100vw;
    max-width: 400px;
  }

  &.s {
    width: 450px;
    width: 100vw;
    max-width: 450px;
  }

  &.m {
    overflow: hidden;
    width: 100vw;
    max-width: 600px;
  }

  &.l {
    width: 100vw;
    max-width: 1012px;
    overflow: hidden;
  }
}
